export default {
	backendUrl: 'https://backend.edunexus.app',
	centrifugoWsUrl: 'wss://realtime.edunexus.app/connection/websocket',
	aiWorkerUrl: 'https://ai-worker.edunexus.app',
	otpLogin: true,
	razorpayEnv: 'PROD',
	googleMapsApiKey: 'AIzaSyAXREi5qJis5osnHmQPXfs_285B2DciLPU',
	qzCertificate: `-----BEGIN CERTIFICATE-----
MIIEBTCCAu2gAwIBAgIUVbCcyQJAyPRk2cPTbxE4rd+oAkQwDQYJKoZIhvcNAQEL
BQAwgZExCzAJBgNVBAYTAklOMRAwDgYDVQQIDAdHdWphcmF0MQ8wDQYDVQQHDAZS
YWprb3QxETAPBgNVBAoMCEVkdW5leHVzMRMwEQYDVQQLDApJZGVhdGVMYWJzMREw
DwYDVQQDDAhlZHVuZXh1czEkMCIGCSqGSIb3DQEJARYVbWVldEBpZGVhdGVsYWJz
LmNvLmluMB4XDTI2MDUxODEyNTkwNloXDTM2MDUxNTEyNTkwNlowgZExCzAJBgNV
BAYTAklOMRAwDgYDVQQIDAdHdWphcmF0MQ8wDQYDVQQHDAZSYWprb3QxETAPBgNV
BAoMCEVkdW5leHVzMRMwEQYDVQQLDApJZGVhdGVMYWJzMREwDwYDVQQDDAhlZHVu
ZXh1czEkMCIGCSqGSIb3DQEJARYVbWVldEBpZGVhdGVsYWJzLmNvLmluMIIBIjAN
BgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2NQC8mwbI2QzO9ulC2wKhznfrMDE
glPnPIwANghaJVupGO5V1pi/NJnZMboWfU+lFkgv7Y0Lw1d+jEyGNXpwGy+vDoVp
jyHmwtlicV4N+advTs5Ze+CgYnph4ipBY3hksbgGOjv6RfXzw3c7Ms3xmzf+mvhD
XcbgkYddDcshEbIYzKYzwiE6SuiDmiQbhYemr5P42xPl2AQMJ3FsThTRY0GSdiNN
flxztEpckN2oQhG9PAX97cuaI2UZQ4s9+YnIosL3Hoj3RJ8htzsqBYFUcdP7LtnP
HeX14BnRTSBnOg7RgukmSV38Y50pli/UZaz9AOIdkWJwg2BrkJNQkM5PtQIDAQAB
o1MwUTAdBgNVHQ4EFgQUT75W+iHHevjZm5olzh+EywlLLfcwHwYDVR0jBBgwFoAU
T75W+iHHevjZm5olzh+EywlLLfcwDwYDVR0TAQH/BAUwAwEB/zANBgkqhkiG9w0B
AQsFAAOCAQEAy+pahH7jv+PaTD7UwBCc673Umxkuv5nIQyh8a+y6IUIaJVcYdlmP
/H9WmjR40N+e5QkJENtq9/hoKfMi4J/sqkIbuwgnbKKIECSXGVoyGJUXYCEAdurT
TNfJHMxqFr2MIsL2307XJf1OtHLNe2TTSEuwVzvGeOYQ18wXyeY6ceyZqg1PquBH
Gr6+4KnSx6c6XYTYMEnX92oxOh5M0Fh+5qLrGT5tCW0Wf+V/EkET3DCX+ltJ3TL0
cx2EUBMVeepbqRWGNZEZ4XfmkwQPfkEYzeIw/dmY8vX/NAePcGODm09zQtfrrMRt
k+zAOzfj6U00MfCQbTPT4LXn3m1KQeZiPw==
-----END CERTIFICATE-----
`,
};
